/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import styled, { css } from 'styled-components'
import { CellStyle } from '../Body/styles'
import { theme } from '~/styles'

export interface HeaderStyleProps {
  lineHeight?: string
  padding?: string
  alignItems?: string
}

export interface HeaderCellProps {
  clickable?: boolean
}

export const HeaderStyle = styled.div<HeaderStyleProps>`
  display: flex;
  justify-content: space-between;
  align-items: ${({ alignItems }) => alignItems || 'auto'};
  flex: 0 1 auto;
  min-width: fit-content;
  width: 100%;
  height: ${({ lineHeight }) => lineHeight || '47px'};

  border-radius: 4px;
  background-color: ${props => props.theme.colors.colorf3f5f9};
  padding: ${({ padding }) => padding || '16px 0 16px 24px'};
  box-sizing: border-box;

  font-weight: 500;
  font-size: 12px;
  color: ${props => props.theme.colors.color6b7786};
`

export const HeaderCell = styled(CellStyle)<HeaderCellProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

  svg {
    fill: ${theme.colors.colora8abb1};
    color: ${theme.colors.colora8abb1};
  }
`

export const SortIconContainer = styled.div`
  padding: 8px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`
